import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { NavLink, useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import {
  PageSubTitle,
  Loading,
  Company
} from 'components/common/Elements/Elements';
import InputWithUnmaunt from 'components/common/forms/InputWithUnmaunt/InputWithUnmaunt';

import Gateways from '../Gateways/Gateways';
import Networks from '../Networks/Networks';
import Messages from '../Messages/Messages';

import { getRequest } from 'utils/requests';
import { upFirstLetter, filterForArrValues, recordType } from 'utils/common';
import { useRegionalLink } from 'hooks/useRegionalLink';

import classes from './AdditionalContent.module.scss';

const AdditionalContent = ({ id, mode }) => {
  const [loader, setLoader] = useState(true);
  const [customers, setCustomers] = useState([]);
  const [find, setFind] = useState('');
  const generateRegionalPath = useRegionalLink();

  let { url } = useRouteMatch();

  const { t } = useTranslation(['activity']);

  const handleFind = e => {
    setFind(e.target.value);
  };

  const onClearFind = useCallback(() => {
    setFind('');
  }, []);

  const getNetworkUrl = data =>
    generateRegionalPath(
      `${url}/${data.customerId}/platform/networks` +
        (data.networkId ? `/${data.networkId}/network` : '')
    );

  useEffect(() => {
    let cancelled = false;
    getRequest(`/rd/maintenance/sidebar/${id}/${mode}`)
      .then(res => {
        if (!cancelled) {
          setCustomers(res.body.data);
          setLoader(false);
        }
      })
      .catch(err => {
        if (!cancelled) {
          console.log(err);
          setLoader(false);
        }
      });
    return () => (cancelled = true);
  }, [id, mode]);

  if (loader) {
    return <Loading />;
  }

  return (
    <>
      <PageSubTitle
        title={`${find && 'Filtered '}${upFirstLetter(mode)}: ${
          find
            ? filterForArrValues(customers, ['companyName', 'customerId'], find)
                .length
            : customers.length
        }`}
        className={classes.title}
        classNameHeading={classes.heading}
        size={2}
      />
      {mode === 'customers' && (
        <InputWithUnmaunt
          placeholder={t('activity:filters:CUSTOMER_NAME')}
          value={find}
          onChange={handleFind}
          onClearSearch={onClearFind}
          unmauntFunc={onClearFind}
          className={classes.input}
          timeDebounce={0}
        />
      )}

      <ul className={classes.children}>
        {(mode === 'customers'
          ? filterForArrValues(customers, ['companyName', 'customerId'], find)
          : customers
        ).map(item => (
          <li
            key={
              mode === 'customers'
                ? item.customerId
                : mode === 'gateways'
                ? item._id
                : mode === 'networks'
                ? item.networkId
                : item.messageId
            }
            className={classes.item}
          >
            {mode === 'customers' ? (
              <NavLink to={getNetworkUrl(item)}>
                <Company
                  nameCompany={item.companyName}
                  description={item.companySize}
                  country={item.country}
                  domain={item.website}
                  status={item.status}
                  recordType={recordType(item)}
                  customerId={item.customerId}
                />
              </NavLink>
            ) : mode === 'gateways' ? (
              <Gateways data={item} />
            ) : mode === 'networks' ? (
              <NavLink to={getNetworkUrl(item)}>
                <Networks data={item} />
              </NavLink>
            ) : (
              <Messages data={item} />
            )}
          </li>
        ))}
      </ul>
    </>
  );
};

AdditionalContent.propTypes = {
  id: PropTypes.string,
  mode: PropTypes.string
};

export default AdditionalContent;
